<div class="layers-panel" data-testid="layers-panel" role="group" [attr.aria-label]="'map_layers_tr' | translate">
  <div class="layers-head">
    <span class="layers-title">{{ 'map_layers_tr' | translate }}</span>
    <button
      type="button"
      class="layers-settings-toggle"
      data-testid="layers-settings-toggle"
      [attr.aria-expanded]="settingsOpen()"
      [title]="'map_layers_settings_tr' | translate"
      [attr.aria-label]="'map_layers_settings_tr' | translate"
      (click)="toggleSettings()"
    >
      <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
        <path
          d="M19.14 12.94a7.07 7.07 0 0 0 0-1.88l2.03-1.58a.5.5 0 0 0 .12-.64l-1.92-3.32a.5.5 0 0 0-.61-.22l-2.39.96a7.03 7.03 0 0 0-1.62-.94l-.36-2.54a.5.5 0 0 0-.5-.42h-3.84a.5.5 0 0 0-.5.42l-.36 2.54c-.59.24-1.13.56-1.62.94l-2.39-.96a.5.5 0 0 0-.61.22L2.66 8.88a.5.5 0 0 0 .12.64l2.03 1.58a7.07 7.07 0 0 0 0 1.88l-2.03 1.58a.5.5 0 0 0-.12.64l1.92 3.32c.13.22.39.3.61.22l2.39-.96c.49.38 1.03.7 1.62.94l.36 2.54c.05.24.26.42.5.42h3.84c.25 0 .46-.18.5-.42l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.48 0 .61-.22l1.92-3.32a.5.5 0 0 0-.12-.64l-2.03-1.58ZM12 15.6a3.6 3.6 0 1 1 0-7.2 3.6 3.6 0 0 1 0 7.2Z"
        />
      </svg>
    </button>
  </div>
  @if (showWhisp()) {
    <label>
      <input type="checkbox" data-testid="layer-whisp" [checked]="state().whisp" (change)="toggleWhisp()" />
      {{ 'map_layer_whisp_tr' | translate }}
      @if (whispStale()) {
        <span class="stale-mark" data-testid="layer-whisp-stale" [title]="'map_layer_whisp_stale_tr' | translate">!</span>
      }
    </label>
  }
  @if (showWhispDebug()) {
    <label>
      <input type="checkbox" data-testid="layer-whisp-debug" [checked]="state().whispDebug" (change)="toggleWhispDebug()" />
      Whisp-Debug
      @if (whispStale()) {
        <span class="stale-mark" data-testid="layer-whisp-debug-stale" [title]="'map_layer_whisp_stale_tr' | translate">!</span>
      }
    </label>
  }
  @for (layer of forestLayers; track layer.id) {
    <label>
      <input
        type="checkbox"
        [attr.data-testid]="'layer-' + layer.id"
        [checked]="state().forest[layer.id]"
        (change)="toggleForest(layer.id)"
      />
      {{ layer.labelKey | translate }}
    </label>
  }
  @if (settingsOpen()) {
    <div class="layers-settings" data-testid="layers-settings">
      <fieldset>
        <legend>{{ 'map_basemap_tr' | translate }}</legend>
        <label>
          <input
            type="radio"
            [name]="basemapGroup"
            data-testid="basemap-satellite"
            [checked]="state().basemap === 'satellite'"
            (change)="chooseBasemap('satellite')"
          />
          {{ 'map_basemap_satellite_tr' | translate }}
        </label>
        <label>
          <input
            type="radio"
            [name]="basemapGroup"
            data-testid="basemap-streets"
            [checked]="state().basemap === 'streets'"
            (change)="chooseBasemap('streets')"
          />
          {{ 'map_basemap_streets_tr' | translate }}
        </label>
      </fieldset>
      <label class="opacity">
        {{ 'map_layers_opacity_tr' | translate }}
        <input
          type="range"
          min="0.1"
          max="1"
          step="0.1"
          data-testid="layers-opacity"
          [value]="state().opacity"
          (input)="changeOpacity($event)"
        />
      </label>
    </div>
  }
</div>
